module.exports = __webpack_public_path__ + "assets/3df96f63c09a63bba3754f1bda0ad0ed.png";